import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { authApi } from "@/lib/api";
import { useAuth } from "@/stores/auth";
import { FullPageSpinner } from "@/components/ui/spinner";

export default function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const setSession = useAuth((s) => s.setSession);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = searchParams.get("token");
    if (!token) {
      toast.error("Confirmation link is invalid");
      navigate("/auth/login", { replace: true });
      return;
    }

    authApi
      .confirmEmail(token)
      .then((session) => {
        setSession(session);
        toast.success("Email confirmed — welcome aboard");
        navigate("/app/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Confirmation link has expired — request a new one");
        navigate("/auth/verify-email", { replace: true });
      });
  }, [searchParams, navigate, setSession]);

  return <FullPageSpinner label="Confirming your email…" />;
}
